<!-- <ng-container *ngIf="model$ | async as model">
<app-custom-category-summary [breadcrumbs]="model.breadcrumbs"></app-custom-category-summary>
</ng-container> -->

@if ((facetList$ | async)?.facets; as facets) {
  <div class="inner" [cxFocus]="isDialog ? dialogFocusConfig : {}" (esc)="close($event)" (click)="block($event)">
    <button class="btn btn-white btn-filters" (click)="showAllFacets()">
      {{ "productList.filterBy.label" | cxTranslate }}
    </button>
    @if (model$ | async; as model) {
      <app-custom-sorting [sortOptions]="model.sorts" placeholder="{{ 'productList.sortBy' | cxTranslate }}"
        [modalHeaderTitle]="'productList.sortBy' | cxTranslate" class="btn-filters"
        (click)="this.showFacets ? showAllFacets() : ''"
      [hideSortingFilters]="toggleSortingFilters"></app-custom-sorting>
    }
  </div>
  <div class="inner-facets inner-facets-scroll {{showFacets ? 'is-open' : ''}}">
    @if (showFacets) {
      <div class="facets-wrapper facet-modal is-open">
        <div class="facet-modal-header is-open">
          <h2 class="facet-modal-title">{{ "productList.filterBy.label" | cxTranslate }}</h2>
          <button type="button" class="close" aria-label="Close" (click)="showAllFacets()">
            <app-custom-icons aria-hidden="true" [type]="iconTypes.CLOSE"></app-custom-icons>
          </button>
        </div>
        <cx-active-facets></cx-active-facets>
        <div class="facet-modal-body">
          <div class="facets-items">
            @for (facet of facets; track facet; let i = $index) {
              @if (professional === facet.professional || consumer === !facet.professional) {
                <cx-facet #facetRef [facet]="facet" [cxFocus]="{ lock: true, trap: true }"
                  (unlock)="expandFacetGroup(facet, facetRef)" [class.selected]="isSelected(facet)"
                  [class.expanded]="(isExpanded(facet) | async) || selected === i"
                  [class.collapsed]="(isCollapsed(facet) | async) || selected !== i"
                [selected]="isMobile || selected === i" (click)="toggleSelected(i)"></cx-facet>
              }
            }
            @if (clearFilters) {
              <a routerLink="./" [queryParams]="" class="clear-filters" (click)="showAllFacets()">
                {{ 'productList.clearFilters' | cxTranslate }}
              </a>
            }
          </div>
        </div>
      </div>
    }
  </div>
}